var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleSubscriptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,2.5 H11 Q11.5,2.5 11.5,3 V9 Q11.5,9.5 11,9.5 H1 Q0.5,9.5 0.5,9 V3 Q0.5,2.5 1,2.5 Z M1,2.82 Q0.82,2.82 0.82,3 V9 Q0.82,9.18 1,9.18 H11 Q11.18,9.18 11.18,9 V3 Q11.18,2.82 11,2.82 Z M0.82,4.3 H11.18 V5.3 H0.82 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleSubscriptions);
export default __webpack_public_path__ + "static/media/icon_module_subscriptions.df14e89bf3ca36d3c9b9ee54d59ae3ff.svg";
export { ForwardRef as ReactComponent };